import React from "react";
import { useRouteMatch, Route, Switch } from "react-router-dom";

import { Box } from "@mui/material";
import MintContractList from "../components/mint/MintContractList";
import MintContract from "../components/mint/MintContract";

function Mint() {
    const { url } = useRouteMatch();

    return (
        <Box
            sx={{ minHeight: "78vh", margin: "0 auto", width: "100%" }}
            maxWidth="lg"
        >
            <Switch>
                <Route path={`${url}/`} exact>
                    <MintContractList />
                </Route>
                <Route
                    path={`${url}/:action/:parentId/:tokenId`}
                    render={(props) => (
                        <MintContract
                            mintAction={props.match.params.action}
                            tokenId={props.match.params.tokenId}
                            parentId={props.match.params.parentId}
                        />
                    )}
                />
                <Route path={`${url}/:contractID`}>
                    <MintContract />
                </Route>
            </Switch>
        </Box>
    );
}

export default Mint;
